export default class Utils{
    GetDateFromText(text){
        var d = text.substr(0,2);
        var m = text.substr(3,2);
        var y = text.substr(6,4);
    
        return new Date(`${m}-${d}-${y}`);
    }

    HtmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }
}


// WEBPACK FOOTER //
// ./src/js/utils.js